module.exports = __webpack_public_path__ + "static/media/image036.8678847e.jpg";